import pluralize from 'pluralize';

import { formatDate, formatRole, toSentenceCase } from '../../utils';
import { getRoleName } from '../Person/utils';

export const getAnnouncementCriteria = (announcement) => {
  const {
    buildings,
    roles,
    cameraSystem,
    accessControlSystem,
    startLaunchTime,
    endLaunchTime,
  } = announcement;
  const criteria = [];

  const dateFormat = 'MM.DD.YYYY';
  const startLaunch =
    startLaunchTime && formatDate(startLaunchTime, true, dateFormat);
  const endLaunch =
    endLaunchTime && formatDate(endLaunchTime, true, dateFormat);

  if (buildings?.length) {
    const buildingNames = buildings.map(({ name }) => name);
    const count = buildingNames?.length;
    const displayedBuildingsNames = buildingNames.splice(0, 2).join(', ');
    const othersCount = count && count - 2;
    let properties = `Properties: ${displayedBuildingsNames}`;
    if (othersCount && othersCount > 0) {
      properties += ` and ${othersCount} ${pluralize('other', othersCount)}`;
    }
    criteria.push(properties);
  }
  if (roles?.length) {
    const rolesNames = roles
      .map((roleId) => formatRole(getRoleName(roleId)))
      .join(', ');
    criteria.push(`Roles: ${rolesNames}`);
  }
  if (cameraSystem) {
    criteria.push(`Camera System: ${toSentenceCase(cameraSystem)}`);
  }
  if (accessControlSystem) {
    criteria.push(
      `Access Control System: ${toSentenceCase(accessControlSystem)}`,
    );
  }
  if (startLaunch && endLaunch) {
    criteria.push(`Launched between ${startLaunch} and ${endLaunch}`);
  } else if (startLaunch) {
    criteria.push(`Launched since ${startLaunch}`);
  } else if (endLaunch) {
    criteria.push(`Launched before ${endLaunch}`);
  }
  return criteria.join('\n');
};
